var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActiveTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.9437 0H4.05634C1.81608 0 0 1.81608 0 4.05634V67.9437C0 70.1839 1.81608 72 4.05634 72H67.9437C70.1839 72 72 70.1839 72 67.9437V4.05634C72 1.81608 70.1839 0 67.9437 0Z",
    fill: "#146EB4",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.9437 1.5H4.05634C2.64451 1.5 1.5 2.64451 1.5 4.05634V67.9437C1.5 69.3555 2.64451 70.5 4.05634 70.5H67.9437C69.3555 70.5 70.5 69.3555 70.5 67.9437V4.05634C70.5 2.64451 69.3555 1.5 67.9437 1.5ZM4.05634 0H67.9437C70.1839 0 72 1.81608 72 4.05634V67.9437C72 70.1839 70.1839 72 67.9437 72H4.05634C1.81608 72 0 70.1839 0 67.9437V4.05634C0 1.81608 1.81608 0 4.05634 0Z",
    fill: "#146EB4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5 56H10.5C10.2239 56 10 56.3358 10 56.75C10 57.1642 10.2239 57.5 10.5 57.5H61.5C61.7761 57.5 62 57.1642 62 56.75C62 56.3358 61.7761 56 61.5 56Z",
    fill: "#146EB4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4571 15C36.5462 15 43.9143 22.3681 43.9143 31.4571C43.9143 40.5462 36.5462 47.9143 27.4571 47.9143C18.3681 47.9143 11 40.5462 11 31.4571C11 22.3681 18.3681 15 27.4571 15ZM27.4571 17.2071C19.5871 17.2071 13.2071 23.5871 13.2071 31.4571C13.2071 39.3272 19.5871 45.7072 27.4571 45.7072C35.3272 45.7072 41.7072 39.3272 41.7072 31.4571C41.7072 23.5871 35.3272 17.2071 27.4571 17.2071ZM26.4286 22.6768C26.9974 22.6768 27.4657 23.1072 27.5256 23.6601L27.5321 23.7803V32.3102L33.0635 35.0762C33.5723 35.3306 33.7987 35.925 33.605 36.4463L33.557 36.5567C33.3027 37.0655 32.7083 37.2919 32.1869 37.0982L32.0765 37.0503L25.9351 33.9795C25.5986 33.8113 25.3736 33.485 25.332 33.1167L25.325 32.9925V23.7803C25.325 23.1709 25.8191 22.6768 26.4286 22.6768Z",
    fill: "#146EB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveTime);
export default __webpack_public_path__ + "static/media/active-time.2c48396705950375e3a25c72426d6ffe.svg";
export { ForwardRef as ReactComponent };